/**
 * Phase 16c (ADR-0023 §11): the bireysel edition's subscription and payment words (merged in index.ts under
 * `b2cBilling`, and `platformAudit` for app-core's audit wording of the platform log): the checkout (B2cOdeme,
 * B2cOdemeKart, B2cOdemeTamam), Ayarlar › Abonelik (B2cAbonelik, B2cIptal), the public site (B2cTanitim2,
 * B2cFiyatlar2 since 16c.2), the cookie note, and Platform's payments, payment card, code box limit and Denetim kaydı. Turkish
 * first; the English mirrors it key for key. A date is followed by "tarihine kadar", never by a suffix.
 */
export const b2cBillingTr = {
  b2cBilling: {
    periods: {
      monthly: 'Aylık',
      yearly: 'Yıllık',
      product: { monthly: 'Oppy Pro · Aylık', yearly: 'Oppy Pro · Yıllık' },
      pro: { monthly: 'Pro · Aylık', yearly: 'Pro · Yıllık' },
    },
    form: {
      title: 'Kart bilgileri',
      noCharge: 'Ücret alınmaz',
      note: 'Ödeme onaylanınca bu pencere kendiliğinden kapanır. Banka ekranında vazgeçerseniz karttan para çekilmez.',
      placeholder: {
        title: 'Ödeme formu burada açılır',
        body: 'Kart numarası, son kullanma tarihi, güvenlik kodu ve bankanın 3D Secure doğrulaması ödeme sağlayıcısının kendi formunda yapılır. Oppy bu alana dokunmaz.',
      },
      test: {
        badge: 'Test',
        note: 'Sahte ödeme sağlayıcısı: gerçek para çekilmez. Yalnız geliştirme ve testler içindir.',
        cards: 'Deneme kartı',
        card: {
          success: 'Ödeme başarılı',
          renewal_declines: 'Şimdi başarılı, yenilemede reddedilir',
          decline: 'Kart reddedilir',
        },
        cancel: 'Bankada vazgeç',
        pay: 'Öde · {{amount}}',
        saveCard: 'Kartı kaydet',
      },
    },
    checkout: {
      where: 'Ödeme',
      back: 'Vazgeç, Chat’e dön',
      closedTitle: 'Ödemeler çok yakında açılıyor',
      closedBody: 'Pro’ya geçiş şu an kapalı. O zamana kadar Ücretsiz paketle devam edebilirsiniz; sohbetleriniz ve belgeleriniz olduğu gibi kalır.',
      title: 'Pro’ya geçin',
      lead: 'Ödeme biter bitmez Pro açılır. Sohbetleriniz ve belgeleriniz olduğu gibi kalır.',
      periodTitle: 'Ödeme sıklığı',
      freeMonths_one: '{{count}} ay bedava',
      freeMonths_other: '{{count}} ay bedava',
      price: { monthly: '{{price}} / ay', yearly: '{{price}} / yıl' },
      monthlyHint: 'Her ay yenilenir',
      yearlyHint: 'Ayda {{price}}’ye gelir',
      detailsTitle: 'Fatura bilgileri',
      optional: '(isteğe bağlı)',
      fields: {
        fullName: 'Ad soyad',
        nationalId: 'T.C. kimlik no',
        nationalIdHint: 'Faturada görünür; boş bırakabilirsiniz.',
        nationalIdPlaceholder: '11 haneli',
        nationalIdKept: 'Kayıtlı: •••••••••{{hint}} (değiştirmek için yazın)',
        province: 'İl',
        district: 'İlçe',
        districtChoose: 'İlçe seçin',
        address: 'Adres',
        companyName: 'Şirket unvanı',
        taxNumber: 'Vergi kimlik no',
        taxOffice: 'Vergi dairesi',
      },
      companyOn: 'Şirket adına fatura istiyorum (vergi no, vergi dairesi)',
      companyOff: 'Şirket adına fatura istemiyorum',
      problems: {
        required: 'Bu alan gerekli.',
        nationalId: 'Bu T.C. kimlik numarası geçerli değil.',
        address: 'Adresi en az 5 karakterle yazın.',
        taxNumber: 'Bu vergi kimlik numarası geçerli değil.',
        accept: 'Devam etmek için iki kutuyu da işaretleyin.',
        fields: 'Fatura bilgilerindeki eksikleri tamamlayın.',
      },
      summary: 'Sipariş özeti',
      limits: 'Günde {{tokens}} token · {{documents}} belge · {{mb}} MB',
      net: 'Tutar (KDV hariç)',
      vat: 'KDV (%20)',
      today: 'Bugün ödenecek',
      renewal: {
        monthly: 'Sonra her ayın {{day}} {{price}} çekilir. İstediğiniz zaman Ayarlar › Abonelik’ten iptal edersiniz.',
        yearly: 'Sonra her yıl {{day}} tarihinde {{price}} çekilir. İstediğiniz zaman Ayarlar › Abonelik’ten iptal edersiniz.',
      },
      acceptJoin: '’nu ve ',
      acceptEnd: '’ni okudum, onaylıyorum.',
      failedTitle: 'Ödeme alınamadı',
      failedBody: 'Karttan para çekilmedi. Başka bir kartla yeniden deneyebilirsiniz.',
      pay: 'Ödemeye geç · {{price}}',
      lock: 'Kart bilgilerinizi ödeme sağlayıcısının formuna girersiniz. Kart numaranız Oppy’ye gelmez, Oppy’de saklanmaz.',
      lockTest: 'Bu kurulumda sahte ödeme sağlayıcısı açık: deneme formu açılır, gerçek para çekilmez.',
    },
    welcome: {
      title: 'Pro’ya hoş geldiniz',
      paid: 'Ödemeniz alındı: {{amount}}. Faturanız e-posta adresinize gönderilecek.',
      open: 'Şu an açık',
      tokens: 'Günde {{tokens}} token',
      documents: '{{documents}} belge',
      files: 'Dosyalar en çok {{mb}} MB',
      connections: 'Kendi bağlantılarınız (MCP)',
      next: 'Sonraki ödeme: {{date}}, {{amount}}. Ayarlar › Abonelik’ten yönetirsiniz.',
      details: 'Abonelik ayrıntıları',
      start: 'Sohbete başla',
    },
    subscription: {
      upgradeOpen: 'Pro ile günde daha çok token, daha çok belge, daha büyük dosyalar ve kendi bağlantılarınız.',
      state: { active: 'Etkin', cancelled: 'İptal edildi', pastDue: 'Ödeme alınamadı' },
      price: 'Fiyat',
      priceValue: { monthly: '{{price}} / ay · KDV dahil', yearly: '{{price}} / yıl · KDV dahil' },
      next: 'Sonraki ödeme',
      nextValue: '{{date}} · {{price}}',
      switchValue: 'Yıllığa geçiş {{date}} · {{price}}',
      until: 'Pro açık',
      untilValue: '{{date}} tarihine kadar; sonra Ücretsiz',
      retry: 'Yeniden deneme',
      retryValue: '{{date}} · kalan deneme: {{left}}',
      card: 'Ödeme yöntemi',
      cardValue: 'Kart •••• {{last4}}',
      changeCard: 'Kartı değiştir',
      cardForm: 'Oppy Pro · yenilemeler için kart',
      pending: 'Pro’nun yeni değerleri {{date}} tarihinde başlayan dönemden geçerli olacak: {{price}}.',
      toYearly: 'Yıllığa geç',
      toYearlyFree_one: 'Yıllığa geç · {{count}} ay bedava',
      toYearlyFree_other: 'Yıllığa geç · {{count}} ay bedava',
      stayMonthly: 'Aylıkta kal',
      cancel: 'Aboneliği iptal et',
      resume: 'Aboneliği sürdür',
      month: 'Bu ay toplam',
      monthValue: '{{tokens}} token',
      monthHint: 'Bilgi için; aylık sınır yok',
      invoices: 'Faturalar',
      contractsLine: '{{date}} tarihli satın almada onayladığınız Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi:',
      contractsOpen: 'Aç',
      contractsTitle: 'Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi',
      details: 'Fatura bilgileri',
      detailsHint: 'Bundan sonraki faturalarda bu bilgiler kullanılır.',
      edit: 'Düzenle',
      tax: 'Vergi no {{number}} · {{office}}',
    },
    invoices: {
      date: 'Tarih',
      description: 'Açıklama',
      amount: 'Tutar',
      payment: 'Ödeme',
      number: 'Fatura no',
      download: 'İndir',
      status: { paid: 'Ödendi', refunded: 'İade edildi' },
      preparing: 'Hazırlanıyor · e-postayla gelecek',
      pdf: 'PDF',
    },
    cancel: {
      title: 'Pro aboneliğiniz iptal edilsin mi?',
      lead: 'Pro, ödediğiniz dönemin sonuna kadar, {{date}} tarihine kadar açık kalır. Sonra Ücretsiz pakete geçersiniz ve kartınızdan bir daha para çekilmez.',
      onFree: '{{plan}} pakette',
      tokens: 'Günde {{tokens}} token.',
      documents: 'Belgeleriniz silinmez.',
      documentsOver: '{{count}} belgeniz silinmez. Belge sayınız {{limit}} sınırının altına inene kadar yeni belge yükleyemezsiniz.',
      connections: 'Kendi bağlantılarınız kapanır; Pro’ya dönünce yeniden açılır.',
      files: 'Dosyalar en çok {{mb}} MB olabilir.',
      reason: 'Neden ayrılıyorsunuz?',
      choose: 'Seçin',
      reasons: {
        price: 'Fiyatı yüksek',
        little_use: 'Az kullanıyorum',
        missing_feature: 'İstediğim bir özellik yok',
        other_tool: 'Başka bir araca geçiyorum',
        other: 'Başka bir neden',
      },
      stay: 'Pro’da kal',
      confirm: 'Aboneliği iptal et',
    },
    // 16c.2 (B2cTanitim2, B2cFiyatlar2): the mockups' words, word for word; every number comes from the packages
    site: {
      home: 'Oppy ana sayfa',
      nav: 'Site',
      features: 'Özellikler',
      prices: 'Fiyatlar',
      faq: 'Sık sorulanlar',
      login: 'Giriş yap',
      start: 'Ücretsiz başla',
      openApp: 'Chat’e git',
      seePrices: 'Fiyatları gör',
      landingTitle: 'Oppy · Önce Oppy’ye sorun',
      chip: 'Bireysel kullanım için · Türkçe',
      ask: 'Bir şeye takıldınız mı?',
      hero: 'Önce Oppy’ye sorun.',
      lead: 'Belgelerinizi okur, sorularınızı <b>kaynağıyla</b> yanıtlar; Word, Excel ve sunum dosyalarınızı hazırlar. Türkçe.',
      ticks: {
        card: 'Kart gerekmez',
        tokens: 'Günde {{tokens}} token ücretsiz',
        renew: 'Hakkınız her gece yenilenir',
      },
      shot: {
        label: 'Örnek bir sohbet: kira sözleşmesinden kiracının ödeyeceği masraflar sayfa numaralarıyla çıkarılıyor ve bir Excel dosyası hazırlanıyor.',
        title: 'Kira sözleşmesi masrafları',
        file: 'kira-sozlesmesi.pdf · 12 sayfa',
        ask: 'Kiracının ödemesi gereken masrafları çıkar, Excel’e de koy.',
        read: '12 sayfa okundu · 14 sn',
        answer: 'Sözleşmeye göre kiracının ödeyecekleri:',
        dues: 'Aidat ve ortak alan giderleri',
        bills: 'Elektrik, su, doğalgaz aboneliği ve faturaları',
        repairs: 'Kiracının verdiği zararların onarımı',
        page: 's. {{page}}',
        sheet: 'kiraci-masraflari.xlsx',
        sheetNote: 'Excel · 3 satır, sayfa numaralarıyla',
        download: 'İndir',
        placeholder: 'Bir şey sorun veya belge ekleyin',
      },
      what: {
        label: 'Neler yapar',
        title: 'Okur, yazar, arar, hatırlar.',
        lead: 'Ve her cevabın nereden geldiğini gösterir.',
      },
      feature: {
        connect: {
          title: 'Uygulamalarınıza bağlanır',
          body: 'Not uygulamanız, takviminiz ya da kod deponuz gibi hizmetlere bağlanır.',
          free_one: 'Ücretsiz pakette {{value}} bağlantı.',
          free_other: 'Ücretsiz pakette {{value}} bağlantı.',
          freeUnlimited: 'Ücretsiz pakette sınırsız bağlantı.',
        },
        documents: { title: 'Belgelerinize sorun', body: 'PDF, Word ya da Excel yükleyin. Yanıtlar sayfa ve satır numarasıyla kaynak gösterir.' },
        files: { title: 'Dosya hazırlar', body: 'Rapor, tablo, sunum… Word, Excel, PDF ya da PowerPoint olarak indirirsiniz.' },
        web: { title: 'Web’de arar', body: 'Güncel konularda web’de arar, sayfaları okur ve kaynaklarını gösterir.' },
        skills: { title: 'Skill’ler', body: 'Sık yaptığınız bir işi bir kez tarif edin; Oppy her seferinde aynı şekilde yapar. Hazır kütüphane de var.' },
        memory: { title: 'Hafıza', body: 'Tercihlerinizi hatırlar. Neyi hatırladığını görür, düzeltir ya da silersiniz.' },
      },
      how: {
        label: 'Nasıl başlanır',
        title: 'Kart yok. Kurulum yok. Bekleme yok.',
        account: { title: 'Hesabınızı açın', body: 'E-postanıza gelen kodu girin, bir dakika.' },
        ask: { title: 'Oppy’ye sorun', body: 'Bir cümle yazın ya da dosyanızı sürükleyin.' },
        result: { title: 'Sonucu alın', body: 'Kaynaklı cevabı okuyun, hazırlanan dosyayı indirin.' },
      },
      try: {
        label: 'Deneyin',
        title: 'Mesela bunu Oppy’ye sorun.',
        lead: 'Birini seçin; hesabınızı açınca soru sizi bekliyor olur.',
        examples: {
          contract: 'Bu sözleşmedeki önemli maddeleri sayfa numaralarıyla özetle',
          report: 'Ekim satış Excel’inden grafikli bir rapor hazırla',
          rent: 'Bu hafta çıkan kira artış oranını kaynaklarıyla bul',
          mail: 'Ev sahibime nazik bir kira artışı itiraz e-postası yaz',
          week: 'Haftalık iş listemi önceliğe göre sırala ve günlere böl',
          slides: 'Bu notlardan 5 sayfalık bir sunum hazırla',
        },
      },
      plans: {
        label: 'Fiyatlar',
        title: 'Sormak ücretsiz.',
        lead: 'Çok soranlar için Pro var.',
        perMonth: '/ ay · KDV dahil',
        tokens: 'Günde <b>{{tokens}}</b> token',
        documents_one: '<b>{{value}}</b> belge',
        documents_other: '<b>{{value}}</b> belge',
        skills_one: '{{value}} kendi skill’iniz',
        skills_other: '{{value}} kendi skill’iniz',
        unlimitedSkills: 'sınırsız skill',
        connections_one: '{{value}} bağlantı',
        connections_other: '{{value}} bağlantı',
        unlimitedConnections: 'sınırsız bağlantı',
        unlimitedBoth: 'sınırsız skill ve bağlantı',
        noCard: 'Kart gerekmez.',
        yearly_one: 'Yıllıkta {{count}} ay bedava.',
        yearly_other: 'Yıllıkta {{count}} ay bedava.',
        compare: 'Paketleri karşılaştır →',
      },
      band: {
        title: 'Takıldığınız ilk şeyi şimdi sorun.',
        landing: 'Kart gerekmez, bir dakikada başlarsınız.',
        prices: 'Sohbetleriniz ve belgeleriniz Pro’ya geçince olduğu gibi kalır.',
      },
      slogan: 'Önce Oppy’ye sor.',
      copyright: '© {{year}} {{vendor}}',
      legal: 'Yasal metinler',
      contact: 'İletişim',
    },
    prices: {
      title: 'Fiyatlar · Oppy',
      label: 'Fiyatlar',
      heading: 'Sormak ücretsiz.',
      headingMore: 'Çok soranlara Pro.',
      lead: 'Fiyatlar KDV dahildir. İstediğiniz zaman iptal edebilirsiniz.',
      period: 'Ödeme sıklığı',
      freeFor: 'Denemek ve ara sıra kullanmak için',
      noCard: 'Kart gerekmez',
      proFor: 'Her gün yoğun kullananlar için',
      per: { monthly: '/ ay', yearly: '/ yıl' },
      proNoteYearly_one: 'KDV dahil · yıllık alırsanız {{price}} <b>({{count}} ay bedava)</b>',
      proNoteYearly_other: 'KDV dahil · yıllık alırsanız {{price}} <b>({{count}} ay bedava)</b>',
      proNoteYearlyPlain: 'KDV dahil · yıllık alırsanız {{price}}',
      proNote: 'KDV dahil',
      soon: 'Ödemeler çok yakında açılıyor',
      soonBody: 'Ücretsiz başlayın; açılınca size haber verelim.',
      // 16c.3: a visitor who is not signed in (no e-mail is asked before sign-up, so no "haber verelim")
      soonGuest: 'Ödemeler çok yakında açılıyor.',
      soonBodyGuest: 'Şimdilik Ücretsiz başlayabilirsiniz.',
      lines: {
        tokens: 'Günde <b>{{tokens}}</b> token',
        times: '· {{times}} kat',
        documents_one: '<b>{{value}}</b> belge',
        documents_other: '<b>{{value}}</b> belge',
        files: 'Dosyalar en çok <b>{{mb}} MB</b>',
        skills_one: '{{value}} kendi skill’iniz',
        skills_other: '{{value}} kendi skill’iniz',
        unlimitedSkills: '<b>Sınırsız</b> kendi skill’iniz',
        noSkills: 'Kendi skill’leriniz',
        connections_one: '{{value}} kendi bağlantınız (MCP)',
        connections_other: '{{value}} kendi bağlantınız (MCP)',
        unlimitedConnections: '<b>Sınırsız</b> kendi bağlantınız (MCP)',
        noConnections: 'Kendi bağlantılarınız (MCP)',
        models_one: '<b>{{value}} sohbet modeli</b>: {{names}}',
        models_other: '<b>{{value}} sohbet modeli</b>: {{names}}',
      },
      shared: {
        label: 'İki pakette de',
        labelOne: 'Pakette',
        web: 'Web’de arama',
        files: 'Word, Excel, PDF',
        memory: 'Hafıza',
        library: 'Skill kütüphanesi',
      },
      compare: 'Karşılaştırın',
      feature: 'Özellik',
      groups: { usage: 'Kullanım', personal: 'Kişiselleştirme', features: 'Özellikler' },
      rows: {
        tokens: 'Günlük token',
        documents: 'Belge sayısı',
        fileSize: 'Dosya boyutu',
        skills: 'Kendi skill’leri',
        connections: 'Kendi bağlantıları (MCP)',
        models_one: 'Sohbet modeli',
        models_other: 'Sohbet modelleri',
        basics: 'Web’de arama, skill’ler, hafıza',
        files: 'Dosya hazırlama: Word, Excel, PDF, sunum',
      },
      mb: 'en çok {{mb}} MB',
      unlimited: 'Sınırsız',
      yes: 'Var',
      no: 'Yok',
      faq: {
        token: { q: 'Token nedir?', a: 'Modelin okuduğu ve yazdığı metin parçasıdır. Kısa bir soru ve cevap birkaç bin token tutar; belgeyle çalışılan bir soru 10–50 bin.' },
        used: { q: 'Hakkım biterse ne olur?', a: 'Sohbetleriniz ve belgeleriniz kalır. Hakkınız her gece 00:00’da yenilenir; beklemek istemezseniz Pro’ya geçersiniz.' },
        cancel: { q: 'İptal edebilir miyim?', a: 'Ayarlar › Abonelik’ten iki tıkla. Pro, ödediğiniz dönemin sonuna kadar açık kalır.' },
        invoice: { q: 'Faturamı nereden alırım?', a: 'Faturanız e-posta adresinize gönderilir; Ayarlar › Abonelik’te de listelenir.' },
        mcp: {
          q: 'Bağlantı (MCP) nedir?',
          a: 'Oppy’nin başka uygulamalardaki araçları kullanmasını sağlar; örneğin not uygulamanız ya da takviminiz.',
          limits: 'Ücretsiz pakette {{free}}, Pro’da {{pro}}.',
          unlimited: 'sınırsız',
          none: 'yok',
        },
        data: { q: 'Verilerimi silebilir miyim?', a: 'Sohbetlerinizi, belgelerinizi ve Oppy’nin hafızasını istediğiniz zaman silersiniz.' },
      },
    },
    cookies: {
      label: 'Çerezler',
      only: 'Yalnız zorunlu çerezler kullanıyoruz. Ayrıntılar:',
      ok: 'Tamam',
      title: 'Çerezler.',
      consent: 'Sitenin çalışması için zorunlu çerezleri kullanırız. Ziyaretleri ölçen çerezler yalnız izin verirseniz açılır. Ayrıntılar:',
      custom: 'Seçerek ayarla',
      necessary: 'Yalnız zorunlu',
      all: 'Tümüne izin ver',
    },
    capacity: {
      boxes: {
        title: 'Aynı anda çalışan kod kutuları',
        hint: 'Dosya hazırlama ve kod çalıştırma için aynı anda en çok bu kadar kutu açılır (kişi başına 2). Fazlası sırada bekler, Pro önce; kişi yalnız olağan çalışma durumunu görür.',
        unit: 'kutu',
        invalid: '1 ile 200 arasında bir sayı yazın.',
      },
      unsaved: 'Kaydedilmedi',
    },
    plansCard: {
      label: 'Ödeme',
      provider: 'Ödeme sağlayıcısı',
      providers: { none: 'iyzico', fake: 'Sahte sağlayıcı', iyzico: 'iyzico' },
      state: { none: 'Bağlı değil', test: 'Test', live: 'Canlı', down: 'Ulaşılamıyor' },
      noneHint: 'Ödemeler açılınca bağlanır (16d). O zamana kadar Pro’ya geç “yakında” der; Pro’yu Kullanıcılar’dan elle verirsiniz.',
      testHint: 'Yalnız geliştirme ve testler: deneme formu açılır, gerçek para çekilmez. Üretimde açılamaz.',
      keysHint: 'Anahtarlar sunucuda; burada gösterilmez.',
      check: 'Bağlantıyı denetle',
      failed: 'Ödeme alınamazsa',
      retries: '{{days}} gün arayla {{count}} kez yeniden denenir',
      retriesHint: 'Her denemede kişiye e-posta gider. Sonuncusu da olmazsa kişi Ücretsiz pakete geçer.',
      invoice: 'Fatura',
      invoiceValue: 'Oppy’de kayıt · KDV %{{vat}}',
      invoiceHint: 'Muhasebe programı henüz bağlı değil. Fatura numarası ve PDF Abonelikler ve ödemeler’den girilir; kayıtlar oradan dışa aktarılır.',
    },
    platform: {
      tab: 'Abonelikler ve ödemeler',
      title: 'Abonelikler ve ödemeler',
      csv: 'Muhasebe için dışa aktar (CSV)',
      tiles: {
        active: 'Etkin Pro',
        activeSub: '{{monthly}} aylık · {{yearly}} yıllık',
        taken: '{{month}} tahsilatı',
        takenSub_one: 'KDV dahil · {{count}} ödeme',
        takenSub_other: 'KDV dahil · {{count}} ödeme',
        retrying: 'Alınamayan ödeme',
        retryingSub: 'yeniden denenecek',
        cancelled: '{{month}} iptali',
        cancelledSub: 'dönem sonunda Ücretsiz’e geçer',
      },
      filters: 'Ödeme durumu',
      chips: { all: 'Tümü', paid: 'Ödendi', failed: 'Alınamadı', refunded: 'İade' },
      month: 'Ay',
      thisMonth: 'Bu ay',
      search: 'Kişi ya da e-posta',
      columns: { date: 'Tarih', person: 'Kişi', plan: 'Paket', amount: 'Tutar', payment: 'Ödeme', invoice: 'Fatura' },
      status: { pending: 'Bekliyor', paid: 'Ödendi', failed: 'Alınamadı', refunded: 'İade edildi' },
      retryOn: '{{n}}. yeniden deneme {{date}}',
      failedFinal: 'Son deneme de olmadı · Ücretsiz’e geçti',
      toIssue: 'Kesilecek',
      noPdf: 'PDF yok',
      empty: 'Bu ay ödeme yok.',
      noun: 'ödeme',
      actions: '{{name}}: işlemler',
      enterNumber: 'Fatura numarası gir',
      changeNumber: 'Fatura numarasını değiştir',
      uploadPdf: 'Fatura PDF’ini yükle',
      replacePdf: 'Fatura PDF’ini değiştir',
      downloadPdf: 'Fatura PDF’ini indir',
      refund: 'İade et',
      note: 'Kart bilgisi Oppy’de tutulmaz; her ödemede sağlayıcının ödeme numarası saklanır. “Kesilecek”: fatura henüz kesilmedi; muhasebe programı bağlanınca numara oradan gelir.',
      numberTitle: 'Fatura numarası',
      numberHint: '{{name}} için muhasebe programının verdiği numara. Numara ve PDF girilince kişiye e-posta gider.',
      number: 'Numara',
      refundTitle: 'Ödeme iade edilsin mi?',
      refundBody: '{{name}} için {{amount}} ödeme sağlayıcısından geri gönderilir. Abonelik kendiliğinden değişmez.',
      refundReason: 'Neden',
    },
    users: { subscription: 'Pro · abonelik' },
    legalLinks: 'Yasal metinler',
    audit: {
      hint: 'Giriş, paket, ödeme, kapasite, e-posta ve sistem olayları tek yerde. Sohbet içeriği burada yer almaz.',
      tabs: { all: 'Tümü', access: 'Giriş ve erişim', plans: 'Paketler', billing: 'Ödemeler', capacity: 'Kapasite', models: 'Modeller', mail: 'E-posta', system: 'Sistem' },
    },
  },
  platformAudit: {
    queueChanged: 'Model sırası değişti',
    share: 'Bireysel pay {{from}} → {{to}}',
    order: 'sıra: {{order}}',
    orders: { pro_first: 'Pro önce', arrival: 'geliş sırasıyla' },
    sandboxes: 'Aynı anda en çok {{from}} → {{to}} kod kutusu',
    to: 'Kime: {{person}}',
    reason: 'Neden: {{reason}}',
    until: '{{date}} tarihine kadar',
    endedOn: 'Bitiş: {{date}}',
    monthly: 'Aylık {{from}} → {{to}}',
    yearly: 'Yıllık {{from}} → {{to}}',
    tokens: 'Günlük token {{from}} → {{to}}',
    documents: 'Belge {{from}} → {{to}}',
    mb: 'Dosya {{from}} → {{to}} MB',
    connectionsOn: 'Kendi bağlantıları açıldı',
    connectionsOff: 'Kendi bağlantıları kapandı',
    unlimited: 'sınırsız',
    ownSkills: 'Kendi skill’leri {{from}} → {{to}}',
    ownConnections: 'Kendi bağlantıları {{from}} → {{to}}',
    chatModels: 'Sohbet modelleri: {{from}} → {{to}}',
    defaultModel: 'Yeni sohbette seçili gelen: {{from}} → {{to}}',
    via: { settings: 'Ayarlar’dan', link: 'e-postadaki bağlantıdan' },
    people_one: '{{count}} kişiye',
    people_other: '{{count}} kişiye',
    effective: '{{date}} tarihinde başlıyor',
    subscribers_one: '{{count}} aboneye duyurulacak',
    subscribers_other: '{{count}} aboneye duyurulacak',
    method: { email_code: 'E-posta kodla doğrulandı' },
    operator: 'Platform yöneticisi',
    periods: { monthly: 'Pro · Aylık', yearly: 'Pro · Yıllık' },
    onRetry: 'yeniden denemede alındı',
    failures: {
      card_declined: 'kart reddedildi',
      cancelled: 'ödeme formunda vazgeçildi',
      insufficient_funds: 'bakiye yetersiz',
      duplicate: 'abonelik zaten vardı',
      order_closed: 'ödeme süresi dolmuştu',
    },
    refundedAuto: 'ödeme iade edildi',
    lastTry: 'Son deneme de olmadı · Ücretsiz’e geçti',
    retryOn: '{{n}}. yeniden deneme {{date}}',
    ended: { canceled: 'İptal edilmişti · Ücretsiz’e geçti', payment_failed: 'Ödeme alınamadı · Ücretsiz’e geçti' },
    cancelReasons: {
      price: 'Neden: fiyatı yüksek',
      little_use: 'Neden: az kullanıyor',
      missing_feature: 'Neden: istediği bir özellik yok',
      other_tool: 'Neden: başka bir araca geçiyor',
      other: 'Neden: başka',
    },
    freeFrom: '{{date}} tarihinde Ücretsiz’e geçer',
    from: '{{date}} tarihinden',
    card: 'Kart •••• {{last4}}',
    newMonthly: 'Aylık {{price}}',
    newTokens: 'günde {{tokens}} token',
    rows_one: '{{count}} ödeme',
    rows_other: '{{count}} ödeme',
  },
};

export const b2cBillingEn: typeof b2cBillingTr = {
  b2cBilling: {
    periods: {
      monthly: 'Monthly',
      yearly: 'Yearly',
      product: { monthly: 'Oppy Pro · Monthly', yearly: 'Oppy Pro · Yearly' },
      pro: { monthly: 'Pro · Monthly', yearly: 'Pro · Yearly' },
    },
    form: {
      title: 'Card details',
      noCharge: 'No charge',
      note: 'This window closes by itself once the payment is confirmed. If you cancel on the bank’s screen, nothing is charged.',
      placeholder: {
        title: 'The payment form opens here',
        body: 'The card number, expiry date, security code and the bank’s 3D Secure check go into the payment provider’s own form. Oppy never touches it.',
      },
      test: {
        badge: 'Test',
        note: 'Fake payment provider: no real money is charged. For development and tests only.',
        cards: 'Test card',
        card: {
          success: 'Payment succeeds',
          renewal_declines: 'Succeeds now, declined at renewal',
          decline: 'Card is declined',
        },
        cancel: 'Cancel at the bank',
        pay: 'Pay · {{amount}}',
        saveCard: 'Save the card',
      },
    },
    checkout: {
      where: 'Payment',
      back: 'Cancel, back to Chat',
      closedTitle: 'Payments open very soon',
      closedBody: 'Upgrading to Pro is not open yet. Until then you can go on with the Free plan; your conversations and documents stay as they are.',
      title: 'Upgrade to Pro',
      lead: 'Pro opens as soon as the payment goes through. Your conversations and documents stay as they are.',
      periodTitle: 'Billing period',
      freeMonths_one: '{{count}} month free',
      freeMonths_other: '{{count}} months free',
      price: { monthly: '{{price}} / month', yearly: '{{price}} / year' },
      monthlyHint: 'Renews every month',
      yearlyHint: '{{price}} a month',
      detailsTitle: 'Billing details',
      optional: '(optional)',
      fields: {
        fullName: 'Full name',
        nationalId: 'Turkish ID number',
        nationalIdHint: 'Shown on the invoice; you may leave it empty.',
        nationalIdPlaceholder: '11 digits',
        nationalIdKept: 'Kept: •••••••••{{hint}} (type to change it)',
        province: 'Province',
        district: 'District',
        districtChoose: 'Choose a district',
        address: 'Address',
        companyName: 'Company name',
        taxNumber: 'Tax number',
        taxOffice: 'Tax office',
      },
      companyOn: 'I want an invoice in a company’s name (tax number, tax office)',
      companyOff: 'I do not want a company invoice',
      problems: {
        required: 'This field is required.',
        nationalId: 'This Turkish ID number is not valid.',
        address: 'Write the address with at least 5 characters.',
        taxNumber: 'This tax number is not valid.',
        accept: 'Tick both boxes to go on.',
        fields: 'Complete what is missing in the billing details.',
      },
      summary: 'Order summary',
      limits: '{{tokens}} tokens a day · {{documents}} documents · {{mb}} MB',
      net: 'Amount (excl. VAT)',
      vat: 'VAT (20%)',
      today: 'Due today',
      renewal: {
        monthly: 'Then {{price}} on day {{day}} of every month. Cancel any time in Settings › Subscription.',
        yearly: 'Then {{price}} every year on {{day}}. Cancel any time in Settings › Subscription.',
      },
      acceptJoin: ' and the ',
      acceptEnd: ': I have read them and I accept them.',
      failedTitle: 'The payment was not taken',
      failedBody: 'Nothing was charged. You can try again with another card.',
      pay: 'Go to payment · {{price}}',
      lock: 'You enter your card details in the payment provider’s form. Your card number never reaches Oppy and is not kept by Oppy.',
      lockTest: 'The fake payment provider is on here: a test form opens and no real money is charged.',
    },
    welcome: {
      title: 'Welcome to Pro',
      paid: 'Your payment was received: {{amount}}. Your invoice will be sent to your email address.',
      open: 'Open now',
      tokens: '{{tokens}} tokens a day',
      documents: '{{documents}} documents',
      files: 'Files up to {{mb}} MB',
      connections: 'Your own connections (MCP)',
      next: 'Next payment: {{date}}, {{amount}}. You manage it in Settings › Subscription.',
      details: 'Subscription details',
      start: 'Start chatting',
    },
    subscription: {
      upgradeOpen: 'Pro gives more tokens a day, more documents, larger files and your own connections.',
      state: { active: 'Active', cancelled: 'Cancelled', pastDue: 'Payment not taken' },
      price: 'Price',
      priceValue: { monthly: '{{price}} / month · VAT included', yearly: '{{price}} / year · VAT included' },
      next: 'Next payment',
      nextValue: '{{date}} · {{price}}',
      switchValue: 'Goes yearly on {{date}} · {{price}}',
      until: 'Pro is on',
      untilValue: 'until {{date}}; then Free',
      retry: 'Next try',
      retryValue: '{{date}} · tries left: {{left}}',
      card: 'Payment method',
      cardValue: 'Card •••• {{last4}}',
      changeCard: 'Change card',
      cardForm: 'Oppy Pro · card for renewals',
      pending: 'Pro’s new values apply from the period that starts on {{date}}: {{price}}.',
      toYearly: 'Go yearly',
      toYearlyFree_one: 'Go yearly · {{count}} month free',
      toYearlyFree_other: 'Go yearly · {{count}} months free',
      stayMonthly: 'Stay monthly',
      cancel: 'Cancel subscription',
      resume: 'Keep subscription',
      month: 'This month in total',
      monthValue: '{{tokens}} tokens',
      monthHint: 'For information; there is no monthly limit',
      invoices: 'Invoices',
      contractsLine: 'The Ön Bilgilendirme Formu and Mesafeli Satış Sözleşmesi you accepted with your purchase on {{date}}:',
      contractsOpen: 'Open',
      contractsTitle: 'Ön Bilgilendirme Formu and Mesafeli Satış Sözleşmesi',
      details: 'Billing details',
      detailsHint: 'The next invoices use these details.',
      edit: 'Edit',
      tax: 'Tax number {{number}} · {{office}}',
    },
    invoices: {
      date: 'Date',
      description: 'Description',
      amount: 'Amount',
      payment: 'Payment',
      number: 'Invoice no.',
      download: 'Download',
      status: { paid: 'Paid', refunded: 'Refunded' },
      preparing: 'Being prepared · comes by email',
      pdf: 'PDF',
    },
    cancel: {
      title: 'Cancel your Pro subscription?',
      lead: 'Pro stays on until the end of the period you paid for, {{date}}. Then you move to the Free plan and your card is not charged again.',
      onFree: 'On the {{plan}} plan',
      tokens: '{{tokens}} tokens a day.',
      documents: 'Your documents are kept.',
      documentsOver: 'Your {{count}} documents are kept. Until you have fewer than {{limit}}, no new document can be added.',
      connections: 'Your own connections are off; they come back with Pro.',
      files: 'Files may be at most {{mb}} MB.',
      reason: 'Why are you leaving?',
      choose: 'Choose',
      reasons: {
        price: 'It costs too much',
        little_use: 'I use it little',
        missing_feature: 'A feature I want is missing',
        other_tool: 'I am moving to another tool',
        other: 'Another reason',
      },
      stay: 'Stay on Pro',
      confirm: 'Cancel subscription',
    },
    site: {
      home: 'Oppy home',
      nav: 'Site',
      features: 'Features',
      prices: 'Pricing',
      faq: 'FAQ',
      login: 'Sign in',
      start: 'Start for free',
      openApp: 'Go to Chat',
      seePrices: 'See pricing',
      landingTitle: 'Oppy · Ask Oppy first',
      chip: 'For personal use · Turkish',
      ask: 'Stuck on something?',
      hero: 'Ask Oppy first.',
      lead: 'It reads your documents, answers your questions <b>with sources</b> and prepares your Word, Excel and presentation files. In Turkish.',
      ticks: {
        card: 'No card needed',
        tokens: '{{tokens}} tokens a day for free',
        renew: 'Your allowance renews every night',
      },
      shot: {
        label: 'A sample chat: the costs a tenant pays are taken from a rental contract with their page numbers, and an Excel file is prepared.',
        title: 'Rental contract costs',
        file: 'kira-sozlesmesi.pdf · 12 pages',
        ask: 'List the costs the tenant has to pay, and put them in Excel too.',
        read: '12 pages read · 14 s',
        answer: 'Under the contract the tenant pays:',
        dues: 'Building fees and shared area costs',
        bills: 'Electricity, water and gas subscriptions and bills',
        repairs: 'Repairs of damage the tenant causes',
        page: 'p. {{page}}',
        sheet: 'kiraci-masraflari.xlsx',
        sheetNote: 'Excel · 3 rows, with page numbers',
        download: 'Download',
        placeholder: 'Ask something or add a document',
      },
      what: {
        label: 'What it does',
        title: 'It reads, writes, searches, remembers.',
        lead: 'And shows where every answer comes from.',
      },
      feature: {
        connect: {
          title: 'Connects to your apps',
          body: 'It connects to services such as your notes app, your calendar or your code repository.',
          free_one: '{{value}} connection on the Free plan.',
          free_other: '{{value}} connections on the Free plan.',
          freeUnlimited: 'Unlimited connections on the Free plan.',
        },
        documents: { title: 'Ask your documents', body: 'Upload a PDF, Word or Excel file. Answers cite the page and the row.' },
        files: { title: 'Makes files', body: 'Reports, tables, presentations… you download them as Word, Excel, PDF or PowerPoint.' },
        web: { title: 'Searches the web', body: 'For current topics it searches the web, reads the pages and shows its sources.' },
        skills: { title: 'Skills', body: 'Describe a task you do often once; Oppy does it the same way every time. There is a ready library too.' },
        memory: { title: 'Memory', body: 'It remembers your preferences. You see what it remembers, correct it or delete it.' },
      },
      how: {
        label: 'How to start',
        title: 'No card. No setup. No waiting.',
        account: { title: 'Open your account', body: 'Type the code sent to your email; it takes a minute.' },
        ask: { title: 'Ask Oppy', body: 'Write a sentence or drag your file in.' },
        result: { title: 'Get the result', body: 'Read the answer with its sources, download the file it made.' },
      },
      try: {
        label: 'Try it',
        title: 'For example, ask Oppy this.',
        lead: 'Pick one; when you open your account, the question will be waiting for you.',
        examples: {
          contract: 'Summarize the important clauses of this contract with their page numbers',
          report: 'Make a report with charts from the October sales Excel',
          rent: 'Find this week’s rent increase rate with its sources',
          mail: 'Write a polite email to my landlord objecting to the rent increase',
          week: 'Sort my weekly to-do list by priority and split it into days',
          slides: 'Make a 5-slide presentation from these notes',
        },
      },
      plans: {
        label: 'Pricing',
        title: 'Asking is free.',
        lead: 'Pro is there for those who ask a lot.',
        perMonth: '/ month · VAT included',
        tokens: '<b>{{tokens}}</b> tokens a day',
        documents_one: '<b>{{value}}</b> document',
        documents_other: '<b>{{value}}</b> documents',
        skills_one: '{{value}} skill of your own',
        skills_other: '{{value}} skills of your own',
        unlimitedSkills: 'unlimited skills',
        connections_one: '{{value}} connection',
        connections_other: '{{value}} connections',
        unlimitedConnections: 'unlimited connections',
        unlimitedBoth: 'unlimited skills and connections',
        noCard: 'No card needed.',
        yearly_one: '{{count}} month free with a year.',
        yearly_other: '{{count}} months free with a year.',
        compare: 'Compare plans →',
      },
      band: {
        title: 'Ask the first thing you are stuck on now.',
        landing: 'No card needed, you start in a minute.',
        prices: 'Your conversations and documents stay as they are when you move to Pro.',
      },
      slogan: 'Ask Oppy first.',
      copyright: '© {{year}} {{vendor}}',
      legal: 'Legal texts',
      contact: 'Contact',
    },
    prices: {
      title: 'Pricing · Oppy',
      label: 'Pricing',
      heading: 'Asking is free.',
      headingMore: 'Pro for those who ask a lot.',
      lead: 'Prices include VAT. You can cancel at any time.',
      period: 'Billing period',
      freeFor: 'To try it and use it now and then',
      noCard: 'No card needed',
      proFor: 'For heavy daily use',
      per: { monthly: '/ month', yearly: '/ year' },
      proNoteYearly_one: 'VAT included · {{price}} if you buy a year <b>({{count}} month free)</b>',
      proNoteYearly_other: 'VAT included · {{price}} if you buy a year <b>({{count}} months free)</b>',
      proNoteYearlyPlain: 'VAT included · {{price}} if you buy a year',
      proNote: 'VAT included',
      soon: 'Payments open very soon',
      soonBody: 'Start for free; we will let you know when they open.',
      // 16c.3: a visitor who is not signed in (no e-mail is asked before sign-up, so no "we will let you know")
      soonGuest: 'Payments open very soon.',
      soonBodyGuest: 'For now you can start with Free.',
      lines: {
        tokens: '<b>{{tokens}}</b> tokens a day',
        times: '· {{times}}×',
        documents_one: '<b>{{value}}</b> document',
        documents_other: '<b>{{value}}</b> documents',
        files: 'Files up to <b>{{mb}} MB</b>',
        skills_one: '{{value}} skill of your own',
        skills_other: '{{value}} skills of your own',
        unlimitedSkills: '<b>Unlimited</b> skills of your own',
        noSkills: 'Your own skills',
        connections_one: '{{value}} connection of your own (MCP)',
        connections_other: '{{value}} connections of your own (MCP)',
        unlimitedConnections: '<b>Unlimited</b> connections of your own (MCP)',
        noConnections: 'Your own connections (MCP)',
        models_one: '<b>{{value}} chat model</b>: {{names}}',
        models_other: '<b>{{value}} chat models</b>: {{names}}',
      },
      shared: {
        label: 'In both plans',
        labelOne: 'In the plan',
        web: 'Web search',
        files: 'Word, Excel, PDF',
        memory: 'Memory',
        library: 'Skill library',
      },
      compare: 'Compare',
      feature: 'Feature',
      groups: { usage: 'Usage', personal: 'Personalization', features: 'Features' },
      rows: {
        tokens: 'Tokens a day',
        documents: 'Documents',
        fileSize: 'File size',
        skills: 'Skills of your own',
        connections: 'Connections of your own (MCP)',
        models_one: 'Chat model',
        models_other: 'Chat models',
        basics: 'Web search, skills, memory',
        files: 'Making files: Word, Excel, PDF, presentations',
      },
      mb: 'up to {{mb}} MB',
      unlimited: 'Unlimited',
      yes: 'Yes',
      no: 'No',
      faq: {
        token: { q: 'What is a token?', a: 'A piece of the text the model reads and writes. A short question and answer take a few thousand tokens; a question about a document 10–50 thousand.' },
        used: { q: 'What happens when my allowance runs out?', a: 'Your conversations and documents stay. Your allowance renews every night at 00:00; if you do not want to wait, you upgrade to Pro.' },
        cancel: { q: 'Can I cancel?', a: 'In two clicks in Settings › Subscription. Pro stays on until the end of the period you paid for.' },
        invoice: { q: 'Where do I get my invoice?', a: 'Your invoice is sent to your email address; it is also listed in Settings › Subscription.' },
        mcp: {
          q: 'What is a connection (MCP)?',
          a: 'It lets Oppy use tools in other apps, for example your notes app or your calendar.',
          limits: '{{free}} on the Free plan, {{pro}} on Pro.',
          unlimited: 'unlimited',
          none: 'none',
        },
        data: { q: 'Can I delete my data?', a: 'You delete your conversations, your documents and Oppy’s memory whenever you like.' },
      },
    },
    cookies: {
      label: 'Cookies',
      only: 'We use only the cookies the site needs. Details:',
      ok: 'OK',
      title: 'Cookies.',
      consent: 'We use the cookies the site needs to work. Cookies that measure visits are on only if you allow them. Details:',
      custom: 'Choose',
      necessary: 'Necessary only',
      all: 'Allow all',
    },
    capacity: {
      boxes: {
        title: 'Code boxes running at once',
        hint: 'At most this many boxes run at once for making files and running code (2 per person). The rest wait, Pro first; people see only the usual running state.',
        unit: 'boxes',
        invalid: 'Write a number from 1 to 200.',
      },
      unsaved: 'Not saved',
    },
    plansCard: {
      label: 'Payment',
      provider: 'Payment provider',
      providers: { none: 'iyzico', fake: 'Fake provider', iyzico: 'iyzico' },
      state: { none: 'Not connected', test: 'Test', live: 'Live', down: 'Unreachable' },
      noneHint: 'Connected when payments open (16d). Until then Upgrade to Pro says “soon” and you give Pro by hand in Users.',
      testHint: 'Development and tests only: a test form opens and no real money is charged. It cannot be on in production.',
      keysHint: 'The keys are on the server; they are not shown here.',
      check: 'Check the connection',
      failed: 'When a payment is not taken',
      retries: 'Tried {{count}} more times, {{days}} days apart',
      retriesHint: 'Each try mails the person. If the last one fails too, the person moves to the Free plan.',
      invoice: 'Invoice',
      invoiceValue: 'Kept in Oppy · VAT {{vat}}%',
      invoiceHint: 'No accounting program is connected yet. The invoice number and PDF are entered in Subscriptions and payments; the records are exported from there.',
    },
    platform: {
      tab: 'Subscriptions and payments',
      title: 'Subscriptions and payments',
      csv: 'Export for accounting (CSV)',
      tiles: {
        active: 'Active Pro',
        activeSub: '{{monthly}} monthly · {{yearly}} yearly',
        taken: 'Taken in {{month}}',
        takenSub_one: 'VAT included · {{count}} payment',
        takenSub_other: 'VAT included · {{count}} payments',
        retrying: 'Payments not taken',
        retryingSub: 'to be tried again',
        cancelled: 'Cancelled in {{month}}',
        cancelledSub: 'move to Free at the period’s end',
      },
      filters: 'Payment status',
      chips: { all: 'All', paid: 'Paid', failed: 'Not taken', refunded: 'Refunded' },
      month: 'Month',
      thisMonth: 'This month',
      search: 'Person or email',
      columns: { date: 'Date', person: 'Person', plan: 'Plan', amount: 'Amount', payment: 'Payment', invoice: 'Invoice' },
      status: { pending: 'Pending', paid: 'Paid', failed: 'Not taken', refunded: 'Refunded' },
      retryOn: 'retry {{n}} on {{date}}',
      failedFinal: 'The last try failed too · moved to Free',
      toIssue: 'To be issued',
      noPdf: 'no PDF',
      empty: 'No payments this month.',
      noun: 'payments',
      actions: '{{name}}: actions',
      enterNumber: 'Enter the invoice number',
      changeNumber: 'Change the invoice number',
      uploadPdf: 'Upload the invoice PDF',
      replacePdf: 'Replace the invoice PDF',
      downloadPdf: 'Download the invoice PDF',
      refund: 'Refund',
      note: 'Card details are not kept in Oppy; each payment keeps the provider’s payment number. “To be issued”: the invoice is not issued yet; once an accounting program is connected the number comes from it.',
      numberTitle: 'Invoice number',
      numberHint: 'The number the accounting program gave for {{name}}. Once the number and the PDF are in, the person gets an email.',
      number: 'Number',
      refundTitle: 'Refund this payment?',
      refundBody: '{{amount}} for {{name}} goes back through the payment provider. The subscription does not change by itself.',
      refundReason: 'Reason',
    },
    users: { subscription: 'Pro · subscription' },
    legalLinks: 'Legal texts',
    audit: {
      hint: 'Sign-in, plan, payment, capacity, email and system events in one place. Conversation content is never here.',
      tabs: { all: 'All', access: 'Sign-in and access', plans: 'Plans', billing: 'Payments', capacity: 'Capacity', models: 'Models', mail: 'Email', system: 'System' },
    },
  },
  platformAudit: {
    queueChanged: 'Model queue changed',
    share: 'Personal share {{from}} → {{to}}',
    order: 'queue: {{order}}',
    orders: { pro_first: 'Pro first', arrival: 'by arrival' },
    sandboxes: 'At most {{from}} → {{to}} code boxes at once',
    to: 'To: {{person}}',
    reason: 'Reason: {{reason}}',
    until: 'until {{date}}',
    endedOn: 'Ended: {{date}}',
    monthly: 'Monthly {{from}} → {{to}}',
    yearly: 'Yearly {{from}} → {{to}}',
    tokens: 'Tokens a day {{from}} → {{to}}',
    documents: 'Documents {{from}} → {{to}}',
    mb: 'File {{from}} → {{to}} MB',
    connectionsOn: 'Own connections on',
    connectionsOff: 'Own connections off',
    unlimited: 'unlimited',
    ownSkills: 'Own skills {{from}} → {{to}}',
    ownConnections: 'Own connections {{from}} → {{to}}',
    chatModels: 'Chat models: {{from}} → {{to}}',
    defaultModel: 'Selected in a new chat: {{from}} → {{to}}',
    via: { settings: 'from Settings', link: 'from the link in a mail' },
    people_one: 'to {{count}} person',
    people_other: 'to {{count}} people',
    effective: 'starts on {{date}}',
    subscribers_one: 'to be announced to {{count}} subscriber',
    subscribers_other: 'to be announced to {{count}} subscribers',
    method: { email_code: 'Email verified with a code' },
    operator: 'Platform admin',
    periods: { monthly: 'Pro · Monthly', yearly: 'Pro · Yearly' },
    onRetry: 'taken on a retry',
    failures: {
      card_declined: 'card declined',
      cancelled: 'cancelled in the payment form',
      insufficient_funds: 'insufficient funds',
      duplicate: 'a subscription was already there',
      order_closed: 'the payment’s time had run out',
    },
    refundedAuto: 'payment refunded',
    lastTry: 'The last try failed too · moved to Free',
    retryOn: 'retry {{n}} on {{date}}',
    ended: { canceled: 'It was cancelled · moved to Free', payment_failed: 'Payment not taken · moved to Free' },
    cancelReasons: {
      price: 'Reason: it costs too much',
      little_use: 'Reason: uses it little',
      missing_feature: 'Reason: a feature is missing',
      other_tool: 'Reason: moving to another tool',
      other: 'Reason: other',
    },
    freeFrom: 'moves to Free on {{date}}',
    from: 'from {{date}}',
    card: 'Card •••• {{last4}}',
    newMonthly: 'Monthly {{price}}',
    newTokens: '{{tokens}} tokens a day',
    rows_one: '{{count}} payment',
    rows_other: '{{count}} payments',
  },
};
